// extracted by mini-css-extract-plugin
export default {"pageLayout":"Skills-module__pageLayout___AIm5X"};